import React from 'react'
import {experience} from "./experience"
import ExperienceDisplay from './ExperienceDisplay'


const MoreInfo = () => {
    return (
    <section className="expList">
    {experience.map((hex) =>{
      return <ExperienceDisplay key={hex.name} {...hex}></ExperienceDisplay>
    })}
  </section>
    )

}

export default MoreInfo
